<template>
    <div ref="compareButtonRef" class="compare-button" :class="{ 'visible': playersCount > 0 }">
        <v-badge :content="playersCount.toString()" color="error" :model-value="playersCount > 0">
            <v-btn icon color="blue-darken-2" elevation="6" :loading="loading" @click="openCompareModal">
                <v-icon>mdi-compare</v-icon>
            </v-btn>
        </v-badge>
    </div>
</template>

<script>
export default {
    name: 'CompareButton',
    data() {
        return {
            loading: false
        };
    },
    computed: {
        playersCount() {
            return this.$store.state.playersToCompare.length;
        }
    },
    mounted() {
        this.$eventBus.on('player-compare-update', this.onPlayerCompareUpdate);
    },
    beforeUnmount() {
        this.$eventBus.off('player-compare-update', this.onPlayerCompareUpdate);
    },
    methods: {
        openCompareModal() {
            if (this.$store.state.playersToCompare.length >= 2) {
                this.loading = true;

                // Vergleich in Google Analytics tracken
                this.trackPlayerCompare();

                // Verwende die globale Methode zum Öffnen des Modals
                this.$playerCompareModal();

                this.loading = false;
            }
        },
        onPlayerCompareUpdate() {
            // Animation beim Hinzufügen/Entfernen von Spielern
            this.$nextTick(() => {
                const button = this.$refs.compareButtonRef;
                if (button) {
                    button.classList.add('pulse');
                    setTimeout(() => {
                        button.classList.remove('pulse');
                    }, 500);
                }
            });
        },
        // Neue Methode für Google Analytics Tracking
        trackPlayerCompare() {
            if (typeof window.gtag === 'function') {
                const playersToCompare = this.$store.state.playersToCompare;

                // Erstellen der Event-Parameter
                const eventParams = {
                    event_category: 'Spieler',
                    event_label: 'Vergleich',
                    players_count: playersToCompare.length
                };

                // Füge Informationen zu den verglichenen Spielern hinzu
                playersToCompare.forEach((player, index) => {
                    eventParams[`player_${index + 1}_name`] = player.display_name || player.name || '';

                    // Falls vorhanden, füge auch Team-Informationen hinzu
                    if (player.Mannschaft) {
                        eventParams[`player_${index + 1}_team`] = player.Mannschaft;
                    }
                });

                // Event an Google Analytics senden
                window.gtag('event', 'players_compared', eventParams);
            }
        }
    }
};
</script>

<style scoped>
.compare-button {
    position: fixed;
    bottom: 50px;
    right: 20px;
    z-index: 1000;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
}

.compare-button.visible {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
}

.compare-button.pulse {
    animation: pulse 0.5s ease;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}
</style>